export default __webpack_public_path__ + "static/media/计算机视觉.27be1937.jpg";